import * as React from "react";

interface FeedbackText {
  text: string;
}

const FeedbackText: React.FC<FeedbackText> = (props: FeedbackText) => {
  const { text } = props;

  // eslint-disable-next-line react/jsx-one-expression-per-line
  return (
    <p className="text-dw-grey-11 text-s italic mt-1 mb-2">Feedback: {text}</p>
  );
};

export default FeedbackText;
